import React from "react";
import { StyleSheet, css } from "aphrodite";
import PulseLoader from "react-spinners/PulseLoader";
import styles from "./style";

class CustomLoader extends React.Component {
  state = {
    active: false,
  };

  //   componentWillReceiveProps = (nextProps) => {
  //     if (nextProps.active !== undefined) {
  //       this.setState({
  //         active: nextProps.active,
  //       });
  //     }
  //   };

  render() {
    const { loading } = this.props;
    const override = (React.CSSProperties = {
      display: "block",
      margin: "0 auto",
      //borderColor: "red",
    });

    return (
      <div
        //className="sweet-loading"
        className={
          loading
            ? [css(styles.loadingStyle)]
            : [css(styles.unloadingStyle)]
        }
      >
        <PulseLoader
          cssOverride={override}
          //size={50}
          //color={"#70757a"}
          loading={loading}
          //speedMultiplier={1.5}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    );
  }
}

export default CustomLoader;
